import SignUpHeader from '@/components/partials/SignUpHeader/SignUpHeader.vue';
import SignUpFooter from '@/components/partials/SignUpFooter/SignUpFooter.vue';

export default {
  name: 'SignUp',
  components: {
    SignUpHeader,
    SignUpFooter
  },
}